import { useEffect, useState } from "react";
import { useSupport } from "../SupportContext";
import findSiblingSupportArticlesInCategory from "../utils/findSiblingSupportArticlesInCategory";
import { Article } from "../support.types";

export type Args = {
  articleId: string | null;
};

export function useArticleNavigation({ articleId }: Args) {
  const [prev, setPrev] = useState<Article | null>(null);
  const [next, setNext] = useState<Article | null>(null);

  const { categories } = useSupport();

  useEffect(() => {
    if (!articleId || categories.length === 0) {
      setPrev(null);
      setNext(null);
      return;
    }

    const { prev: foundPrev, next: foundNext } =
      findSiblingSupportArticlesInCategory(categories, articleId);

    setPrev(foundPrev ?? null);

    setNext(foundNext ?? null);
  }, [articleId, categories]);

  return { prev, next };
}

export default useArticleNavigation;
